var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyProfileB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 20.0007C4.29917 20.0007 0 15.7015 0 10.4173C0 5.13315 4.29917 0.833984 9.58333 0.833984C14.8675 0.833984 19.1667 5.13315 19.1667 10.4173C19.1667 15.7015 14.8675 20.0007 9.58333 20.0007ZM9.58333 1.66732C4.75833 1.66732 0.833333 5.59232 0.833333 10.4173C0.833333 15.2423 4.75833 19.1673 9.58333 19.1673C14.4083 19.1673 18.3333 15.2423 18.3333 10.4173C18.3333 5.59232 14.4083 1.66732 9.58333 1.66732Z",
    fill: "#5C678F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5832 15.8343C14.3532 15.8343 14.1665 15.6476 14.1665 15.4176C14.1665 12.8901 12.1107 10.8343 9.58317 10.8343C7.05567 10.8343 4.99984 12.8901 4.99984 15.4176C4.99984 15.6476 4.81317 15.8343 4.58317 15.8343C4.35317 15.8343 4.1665 15.6476 4.1665 15.4176C4.1665 12.431 6.5965 10.001 9.58317 10.001C12.5698 10.001 14.9998 12.431 14.9998 15.4176C14.9998 15.6476 14.8132 15.8343 14.5832 15.8343Z",
    fill: "#5C678F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58317 9.16732C7.97484 9.16732 6.6665 7.85898 6.6665 6.25065C6.6665 4.64232 7.97484 3.33398 9.58317 3.33398C11.1915 3.33398 12.4998 4.64232 12.4998 6.25065C12.4998 7.85898 11.1915 9.16732 9.58317 9.16732ZM9.58317 4.16732C8.43484 4.16732 7.49984 5.10232 7.49984 6.25065C7.49984 7.39898 8.43484 8.33398 9.58317 8.33398C10.7315 8.33398 11.6665 7.39898 11.6665 6.25065C11.6665 5.10232 10.7315 4.16732 9.58317 4.16732Z",
    fill: "#5C678F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyProfileB);
export default __webpack_public_path__ + "static/media/CompanyProfileB.b886979d74c47b913c2ba99a1caf1c5d.svg";
export { ForwardRef as ReactComponent };